import { render, staticRenderFns } from "./CarType.vue?vue&type=template&id=35c224f6"
import script from "./CarType.vue?vue&type=script&lang=js"
export * from "./CarType.vue?vue&type=script&lang=js"
import style0 from "./CarType.vue?vue&type=style&index=0&id=35c224f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports